/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListCustomDetectionRulesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListCustomDetectionRulesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListCustomDetectionRulesSecurity = {
  option1?: ListCustomDetectionRulesSecurityOption1 | undefined;
  option2?: ListCustomDetectionRulesSecurityOption2 | undefined;
};

export type ListCustomDetectionRulesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListCustomDetectionRulesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListCustomDetectionRulesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListCustomDetectionRulesSecurityOption1$Outbound,
    ListCustomDetectionRulesSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listCustomDetectionRulesSecurityOption1ToJSON(
  listCustomDetectionRulesSecurityOption1:
    ListCustomDetectionRulesSecurityOption1,
): string {
  return JSON.stringify(
    ListCustomDetectionRulesSecurityOption1$outboundSchema.parse(
      listCustomDetectionRulesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListCustomDetectionRulesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListCustomDetectionRulesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListCustomDetectionRulesSecurityOption2$Outbound,
    ListCustomDetectionRulesSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listCustomDetectionRulesSecurityOption2ToJSON(
  listCustomDetectionRulesSecurityOption2:
    ListCustomDetectionRulesSecurityOption2,
): string {
  return JSON.stringify(
    ListCustomDetectionRulesSecurityOption2$outboundSchema.parse(
      listCustomDetectionRulesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListCustomDetectionRulesSecurity$Outbound = {
  Option1?: ListCustomDetectionRulesSecurityOption1$Outbound | undefined;
  Option2?: ListCustomDetectionRulesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListCustomDetectionRulesSecurity$outboundSchema: z.ZodMiniType<
  ListCustomDetectionRulesSecurity$Outbound,
  ListCustomDetectionRulesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListCustomDetectionRulesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListCustomDetectionRulesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listCustomDetectionRulesSecurityToJSON(
  listCustomDetectionRulesSecurity: ListCustomDetectionRulesSecurity,
): string {
  return JSON.stringify(
    ListCustomDetectionRulesSecurity$outboundSchema.parse(
      listCustomDetectionRulesSecurity,
    ),
  );
}

/** @internal */
export type ListCustomDetectionRulesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListCustomDetectionRulesRequest$outboundSchema: z.ZodMiniType<
  ListCustomDetectionRulesRequest$Outbound,
  ListCustomDetectionRulesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listCustomDetectionRulesRequestToJSON(
  listCustomDetectionRulesRequest: ListCustomDetectionRulesRequest,
): string {
  return JSON.stringify(
    ListCustomDetectionRulesRequest$outboundSchema.parse(
      listCustomDetectionRulesRequest,
    ),
  );
}
